<h1>Results for: &ldquo;{{searchQuery()}}&rdquo;</h1>
<p>The following is a list of artists matching the query.<br />
  Click the <strong>artist image</strong> for more information.</p>

<br />

<div class="content">
  <div fxLayout="row wrap" fxLayoutGap="16px">
    @for (r of results(); track r.id) {
    <div fxFlex="100" fxFlex.gt-sm="45" fxFlex.gt-md="30" style="margin-bottom: 16px;">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{r.name}}</mat-card-title>
          <mat-card-subtitle>Artist</mat-card-subtitle>
          <app-favourite-heart class="result-heart" [saved]="artistFavourites.ids().has(r.id)" [name]="r.name" list="Favourite Artists"
            (toggled)="artistFavourites.toggle(r.id, r.name)" />
        </mat-card-header>
        <img mat-card-image class="album-cover" [src]="r.images[1]?.url" alt="artist art"
          [routerLink]="['/artist', r.id]" style="cursor: pointer;" />
        <mat-card-content>
          <p><strong>Followers:</strong> {{r.followers.total | number}}</p>
          <p><strong>Popularity:</strong> {{r.popularity}}</p>
        </mat-card-content>
      </mat-card>
    </div>
    }
  </div>
</div>